import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class KsefDocumentIssueDateShouldBeNotFromFutureError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.sale.validation.ksef-document.issue-date-should-be-not-from-future');
    }
}
